export const DeliveryUnit = [
  { value: "", label: "Select delivery unit" },
  { value: "MD", label: "Moldova" },
  { value: "US", label: "USA" },
];
